import { render, staticRenderFns } from "./ExternalInstructions.vue?vue&type=template&id=615786d6&scoped=true"
import script from "./ExternalInstructions.vue?vue&type=script&lang=js"
export * from "./ExternalInstructions.vue?vue&type=script&lang=js"
import style0 from "./ExternalInstructions.vue?vue&type=style&index=0&id=615786d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615786d6",
  null
  
)

export default component.exports